export const NOT_FOUND = {
  key: "importExport.importMembers.errors.code.NotFoundError",
  value: "NotFoundError",
};
export const REGEX_ERROR = {
  key: "importExport.importMembers.errors.code.ValueRegexError",
  value: "ValueRegexError",
};
export const TYPE_ERROR = {
  key: "importExport.importMembers.errors.code.TypeError",
  value: "TypeError",
};
export const DUPLICATE_ERROR = {
  key: "importExport.importMembers.errors.code.DuplicateError",
  value: "DuplicateError",
};
export const MAX_LENGTH_ERROR = {
  key: "importExport.importMembers.errors.code.MaxLengthError",
  value: "MaxLengthError",
};

export default [NOT_FOUND, REGEX_ERROR, TYPE_ERROR, DUPLICATE_ERROR, MAX_LENGTH_ERROR];



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/importMembers/enums/importMemberErrors.js